import { render, staticRenderFns } from "./DepartmentActivityDashboard.vue?vue&type=template&id=50f28bfc&scoped=true"
import script from "./DepartmentActivityDashboard.vue?vue&type=script&lang=js"
export * from "./DepartmentActivityDashboard.vue?vue&type=script&lang=js"
import style1 from "./DepartmentActivityDashboard.vue?vue&type=style&index=1&id=50f28bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f28bfc",
  null
  
)

export default component.exports